import * as moment from 'moment';
import en from 'moment/locale/en-ca';
import fr from 'moment/locale/fr';

export function formatDate(date, lang) {
    let dateFormated = moment(date);
    dateFormated.locale(lang)
    return dateFormated.format('MMM DD, YYYY');
}

export function formatDateOfBirth(date, lang) {
    let dateFormated = moment(date, moment.ISO_8601);
    dateFormated.locale(lang);
    return dateFormated.format('MMM DD, YYYY');
}

/**
 * Format a JS date based on a list of formats and add a delimeter
 * @param {*} date JavaScript Date object
 * @param {*} formats - list of formats to apply to date, following Intl.DateTimeFormat structure
 * @param {*} lang - language code
 * 
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 */
export const intlFormatDate = (date, formats, lang, delimter) => {
    const applyFormat = (structure) => {
        const format = new Intl.DateTimeFormat(lang + '-ca', structure);
        return format.format(date).split('.')[0];
    }
    return formats.map(applyFormat).join(delimter);
}

export const PDF_FILE_NAME_FORMAT = [{ year: 'numeric' }, { month: 'short' }, { day: 'numeric' }];
